import React, { useEffect, useState } from 'react'

const ScrollArrow = () => {
	const [show, setShow] = useState(false)

	const handleScroll = () => {
		if (window && window.scrollY > 400) {
			if (!show) setShow(true)
		} else {
			if (show) setShow(false)
		}
	}

	useEffect(() => {
		if (window) {
			window.addEventListener('scroll', handleScroll)
			return () => window.removeEventListener(`scroll`, handleScroll)
		}
	})

	return (
		<div>
			{show && (
				<button
					onClick={() => window.scrollTo(0, 0)}
					value="scroll to top"
					className="fixed right-[30px] bottom-[100px] z-50 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-gray-100 px-3 py-1 shadow-md hover:bg-gray-200"
					aria-label="scroll to top"
				>
					<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
						<path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
					</svg>
				</button>
			)}
		</div>
	)
}

export default ScrollArrow
